'use strict';

// Full-width card carousels
(function ($) {
	$(document).ready(function () {
		var cardSlide, cardCaption;

		cardSlide = $('.cards__carousel .images .owl-carousel').owlCarousel({
			nav: false,
			dots: false,
			items: 1,
			draggable: false,
			loop: true,
			mouseDrag: false,
			touchDrag: false,
			// animateOut: 'fadeOut',
			// animateIn: 'fadein',
			smartSpeed: 250,
			responsive: {
				768: {
					margin: 0,
					stagePadding: 0
				},
				1280: {
					margin: 0,
					stagePadding: 0
				},
				1440: {
					margin: 0,
					stagePadding: 0
				}
			}
		});

		cardCaption = $('.cards__carousel .captions .owl-carousel').owlCarousel({
			items: 1,
			loop: true,
			nav: true,
			dots: true,
			smartSpeed: 250,
			responsive: {
				1280: {
					width: 440
				}
			}
		});

		cardCaption.on('change.owl.carousel', function (event) {
			if (event.namespace && event.property.name === 'position') {
				var target = event.relatedTarget.relative(event.property.value, true);
				cardSlide.owlCarousel('to', target, 300, true);
			}
		});
	});
})(jQuery);